<template>
  <div>

    <Page>
        <template #subheader>
            <ul class="uk-subnav uk-subnav-pill uk-flex-center category-filter uk-margin-medium-top" uk-margin v-if="readProjectCategories.length">
                <li v-bind:class="{ 'uk-active' : activeCategory == 0 }">
                    <a @click.stop="activeCategory=0">All Projects</a>
                </li>
                <li v-bind:class="{ 'uk-active' : activeCategory == cat.node.id }"  v-for="cat in readProjectCategories">
                    <a @click.stop="activeCategory = cat.node.id">{{cat.node.title}}</a>
                </li>
            </ul>
        </template>

        <div class="uk-section uk-background-white uk-section-medium">
            <div class="uk-container">
                
                <p class="uk-margin-remove-top">
                    {{ $apollo.loading ? "Loading" : filteredProjects.length }} projects
                </p>

                <div class="uk-grid uk-child-width-1-1 uk-child-width-1-2@s uk-child-width-1-3@m" uk-grid uk-height-match="target: .match-height" v-if="!!projectCards.length">
                    <div v-for="project in projectCards" :key="project.urlSegment">
                        {{ project.sticky }}
                        <ProjectCard :project="project.node" />
                    </div>
                </div>

                <div  class="uk-margin-medium-top" v-if="!!projectRows.length">
                    <div v-for="project in projectRows" :key="project.urlSegment">
                        <ProjectRow :project="project.node" />
                    </div>
                </div>

            </div>
        </div>

    </Page>

  </div>
</template>

<script>
import ProjectCard from './ProjectCard.vue'
import ProjectRow from './ProjectRow.vue'
import FloatingBadge  from '../components/FloatingBadge.vue'
import gql from 'graphql-tag'
import _ from 'lodash'

// GraphQL query
const readProjectsQuery = gql`query($offset: Int!) {
    readProjects(limit: 50, offset: $offset) {
        edges {
            node{
                id
                title
                link
                featured
                sticky
                summary
                heroLastName
                image {
                    smallSquare
                    medium4x3
                }
                category {
                    id
                    title
                }
            }
        },
        pageInfo {
            hasNextPage
            totalCount
        }
    }
}`

const readCategoriesQuery = gql`{
  readProjectCategories{
    edges {
      node{
        id
        title
      }
    }
  }
}`


export default {
    inject: [ 'state', 'theme' ],
    data() {
        return {
            activeCategory: 0,
            headline: 'Featured Unsung Hero Projects',
            readProjectCategories: [],
            loading: 0,
            page: 0,
            pageCount: 50,
            allProjects: [],
            pageInfo: {}
        }
    },
    components: {
        ProjectCard,
        ProjectRow,
        FloatingBadge
    },
    apollo: {
        readProjects: {

            // FILTER
            // If no categories, load first page & apply load more function
            // If category is picked, load page, filter enabled
            variables() {
                return {
                    offset: this.page*this.pageCount
                }
            },
            query: readProjectsQuery,
            loadingKey: 'loading',
            update(data) { 
                if(data.readProjects.pageInfo.hasNextPage) {
                    this.page++
                }
                this.pageInfo = data.readProjects.pageInfo
                this.allProjects = this.allProjects.concat(data.readProjects.edges)
            }
        },
        readProjectCategories: {
            query: readCategoriesQuery,
            loadingKey: 'loading',
            update(data) { 
                return data.readProjectCategories.edges
            }
        }
    },
    computed: {
        filteredProjects() {
            var projects = [];
            if(this.activeCategory==0) {
                projects = this.allProjects;
            }
            else {
                projects = this.allProjects.filter(item => {
                    return item.node.category.id == this.activeCategory
                })
            }
            return _.orderBy(projects, 'node.heroLastName', 'asc');
        },
        projectCards() {
            return this.filteredProjects.filter(item => { 
                return item.node.sticky == true })
            
        },
        projectRows() {
            return this.filteredProjects.filter(item => { return item.node.sticky == false })
        }
    },
    methods: {
        showMore () {
            this.page++
            // Fetch more data and transform the original result
            this.$apollo.queries.tagsPage.fetchMore({
                // New variables
                variables: {
                    page: this.page,
                    pageSize
                },
                // Transform the previous result with new data
                updateQuery: (previousResult, { fetchMoreResult }) => {
                const newTags = fetchMoreResult.tagsPage.tags
                const hasMore = fetchMoreResult.tagsPage.hasMore

                this.showMoreEnabled = hasMore

                return {
                    tagsPage: {
                    __typename: previousResult.tagsPage.__typename,
                    // Merging the tag list
                    tags: [...previousResult.tagsPage.tags, ...newTags],
                    hasMore,
                    },
                }
                },
            })
        }
    }
}
</script>
